import { z } from 'zod'
import { supplierPlanSchema } from './supplier-plan'

const shortText = z.string().trim().max(300)
const notes = z.string().trim().max(5000)
const provider = supplierPlanSchema
const extraSong = z.object({ id: z.string().uuid(), moment: shortText.min(1), song: shortText })
const request = z.object({ id: z.string().uuid(), description: shortText.min(1), notes })
export const musicSchema = z.object({
  ceremonyForm: z.enum(['undecided', 'live', 'recorded']),
  ceremonyDetails: shortText,
  ceremonyProvider: provider,
  ceremonyArrival: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
    .or(z.literal('')),
  microphone: z.boolean(),
  ceremonySongs: z.object({
    groom: shortText,
    witnesses: shortText,
    bridesmaids: shortText,
    flowerGirls: shortText,
    bride: shortText,
    rings: shortText,
    congratulations: shortText,
    exit: shortText,
  }),
  ceremonyExtraSongs: z.array(extraSong).max(50),
  partyForm: z.enum(['undecided', 'dj', 'band', 'combined']),
  dj: provider,
  band: provider,
  partySongs: z.object({
    firstDance: shortText,
    parentsDance: shortText,
    cake: shortText,
    bouquet: shortText,
    sparklers: shortText,
  }),
  partyExtraSongs: z.array(extraSong).max(50),
  mustPlay: notes,
  blacklist: notes,
  moderation: z.enum(['undecided', 'dj', 'professional', 'friend']),
  moderator: provider,
  technicalRequests: z.array(request).max(50),
  specialRequests: z.array(request).max(50),
  entertainment: z
    .array(
      supplierPlanSchema.safeExtend({
        id: z.string().uuid(),
        category: z.enum([
          'animator',
          'castle',
          'clown',
          'magician',
          'caricature',
          'tattoo',
          'pyrotechnics',
          'custom',
        ]),
        name: shortText.min(1),
        contact: z.string().trim().max(500),
        notes,
      }),
    )
    .max(50),
})
export type MusicInput = z.infer<typeof musicSchema>
export function emptyMusic(): MusicInput {
  return {
    ceremonyForm: 'undecided',
    ceremonyDetails: '',
    ceremonyProvider: { name: '', contact: '' },
    ceremonyArrival: '',
    microphone: false,
    ceremonySongs: {
      groom: '',
      witnesses: '',
      bridesmaids: '',
      flowerGirls: '',
      bride: '',
      rings: '',
      congratulations: '',
      exit: '',
    },
    ceremonyExtraSongs: [],
    partyForm: 'undecided',
    dj: { name: '', contact: '' },
    band: { name: '', contact: '' },
    partySongs: { firstDance: '', parentsDance: '', cake: '', bouquet: '', sparklers: '' },
    partyExtraSongs: [],
    mustPlay: '',
    blacklist: '',
    moderation: 'undecided',
    moderator: { name: '', contact: '' },
    technicalRequests: [],
    specialRequests: [],
    entertainment: [],
  }
}
